<template>
  <div class="gd-background">
    <div v-if="!traceability.data">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card height="300" color="transparent" flat>
              <div class="display-3 mt-5">Traceability not found.</div>
              <div class="grey--text lighten-5">
                The data you want to search for traceability does not exist or has not been found,
                or has been moved to another source.
              </div>
              <div class="paragraph-text mt-2">
                <br />
                <br />Try going back to home page and repeating your action. Or,
                contact helpdesk for support.
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <template v-else>
      <div :key="trace.id" v-for="trace in traceability.data" :id="trace.name">
        <section><!--drink-->
          <v-parallax :src="getBackgroundImage(trace)" height="300">
            <v-layout column align-center justify-center class="white--text mr-5">
              <div class="white--text mb-3 text-md-center">
                <h1 class="text-executive-lg uppercase">{{ trace.name }}</h1>
              </div>
            </v-layout>
          </v-parallax>
        </section><!--/drink-->
        <section>
          <v-flex xs8 offset-xs2>
            <v-container grid-list-xl class="white--text text-lg-center">
              <v-layout row wrap align-center justify-center>
                <v-container grid-list-xl :key="season" v-for="season in seasons(trace.products)">
                  <h3 class="text-courier-new-md-black">🌱 Harvesting Season <strong class="bold">{{ season }}</strong>
                  </h3>
                  <hr>
                  <v-layout row wrap align-center>
                    <v-flex xs12 sm6 md3 :key="product.id" v-for="product in productsBySeason(season, trace.products)"
                            @click="selectProduct(product)">
                      <figure class="effect-gd pointer tooltip">
                        <div class="tooltiptext traceability">
                          <span>Click to see details</span>
                        </div>
                        <img :src="getPath(product.image_url)" alt="Kopi Ketjil">
                        <figcaption>
                          <h4 class="effect1 text-executive-xs">{{ product.name }}</h4>
                        </figcaption>
                      </figure>
                      <div class="text-courier-new-md-black">
                        {{ product.description }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-container>
          </v-flex>
        </section>
      </div>
    </template>
    <TraceabilityModal v-if="visibleTraceabilityModal" :product="selectedProduct" @close="visibleTraceabilityModal = false"/>
    <FooterApps/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FooterApps from '@/components/FooterApps'
import TraceabilityModal from '@/components/TraceabilityModal'

const MOCK = {
  'state': 'SUCCESS',
  'data': [
    {
      'id': 1,
      'name': 'Farms to Green Bean Hub',
      'created_at': '2018-11-12 18:19:35',
      'updated_at': '2018-11-12 18:19:35',
      'products': [
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'description': 'Batch 1',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'Wikipedia.svg.png',
          'qr_alternate_url': 'https://facebook.com',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        },
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        },
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        },
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        },
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        },
        {
          'id': 104,
          'harvesting_season': '2020',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        }
      ]
    },
    {
      'id': 2,
      'name': 'Farms to Roasters',
      'created_at': '2018-11-12 18:19:35',
      'updated_at': '2018-11-12 18:19:35',
      'products': [
        {
          'id': 104,
          'harvesting_season': '2021',
          'name': 'Americano',
          'image_url': '/gallery/americano.jpg',
          'qr_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
          'shop_url': '/shops/detail/148',
          'gallery_category_id': 1,
          'created_at': '2018-11-16 08:17:44',
          'updated_at': '2018-11-19 07:44:30'
        }
      ]
    }
  ]
}

export default {
  name: 'traceability',
  data () {
    return {
      visibleTraceabilityModal: false,
      selectedProduct: {}
    }
  },
  created () {
    this.getTraceability()
    setTimeout(() => {
      this.scrollToHash()
    }, 150)
  },
  components: {
    TraceabilityModal,
    FooterApps
  },
  computed: {
    ...mapGetters(['traceability'])
    // traceability () {
    //   return MOCK
    // }
  },
  methods: {
    getTraceability () {
      this.$store.dispatch('getTraceability', {
        success: () => {
        },
        fail: () => {
        }
      })
    },
    seasons (products) {
      const data = products.map(item => item.harvesting_season)
      return [...new Set(data)].sort().reverse()
    },
    productsBySeason (season, products) {
      return products.filter(product => product.harvesting_season === season)
    },
    selectProduct (product) {
      this.selectedProduct = { ...product }
      this.visibleTraceabilityModal = true
    },
    getPath (fileName) {
      return 'https://api.kopiketjil.com' + fileName
    },
    getBackgroundImage (traceability) {
      if (traceability.name.toLowerCase() === 'farms to green bean hub') {
        return '/static/img/background-drink.png'
      } else if (traceability.name.toLowerCase() === 'farms to roasters') {
        return '/static/img/background-food.png'
      }
      return '/static/img/background-drink.png'
    },
    scrollToHash () {
      const { hash } = this.$route
      if (hash) {
        let find = hash.replace(/#/g, '')
        find = decodeURI(find)
        const target = document.getElementById(find)
        target.scrollIntoView()
      }
    }
  },
  watch: {
    '$route.hash' () {
      this.scrollToHash()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Traceability.vue